import React, { useState } from "react";
import { Box, Camera } from "lucide-react";
import Seo from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import CadStudio from "@/components/studio/CadStudio";
import PhotoStudio from "@/components/studio/PhotoStudio";

const MODES = [["cad", "3D Design Studio", Box], ["photo", "Your Photo", Camera]];

export default function AIStudio() {
  const [mode, setMode] = useState("cad");
  return (
    <div data-testid="ai-studio-page" className="min-h-screen">
      <Seo title="The Studio — 3D Room Designer" description="The Studio by Rossi Ceramics: a 3D room designer. Shape your room, tile every wall and floor at true scale with real grout lines, place fixtures, and describe changes in plain English." />
      <section className="relative pt-36 lg:pt-44 pb-8">
        <div className="container-rossi">
          <Reveal>
            <p className="eyebrow mb-4">The Studio</p>
            <h1 className="font-serif font-bold text-4xl sm:text-5xl lg:text-6xl text-rossi-cream leading-tight max-w-4xl">Italian materials. <span className="gold-text">Designed by you,</span> built by us.</h1>
            <p className="mt-5 text-rossi-cream/75 max-w-2xl">Shape your room to the millimetre, lay real tiles on every wall and floor with true-to-scale grout, place your bath, shower and vanity — then simply tell The Studio what to change.</p>
          </Reveal>
          <div className="flex gap-2 mt-8" data-testid="studio-mode-tabs">
            {MODES.map(([k, l, Icon]) => (
              <button key={k} onClick={() => setMode(k)} className={`px-5 py-2.5 rounded-full text-sm flex items-center gap-2 transition-colors ${mode === k ? "bg-rossi-gold text-rossi-bg" : "border border-rossi-gold/30 text-rossi-cream/80 hover:bg-rossi-gold/10"}`} data-testid={`studio-mode-${k}`}><Icon size={15} /> {l}</button>
            ))}
          </div>
        </div>
      </section>
      <section className="container-rossi pb-24">
        <div className={mode === "cad" ? "" : "hidden"}><CadStudio /></div>
        {mode === "photo" && <PhotoStudio />}
      </section>
    </div>
  );
}
